import { Injectable } from '@angular/core';
import { translate, TranslocoService } from '@ngneat/transloco';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TranslModule } from './transl.module';

let service: TranslService;

export function t(key: string, tooltipRef?: any) {
    return getTranslService().t(key, tooltipRef?.attributes?.tooltip?.value);
}

export function tKeyVal(key: string) {
    return { key, val: getTranslService().t(key) };
}

export function getTranslService() {
    if (!service) {
        service = TranslModule.injector.get<TranslService>(TranslService);
        return service;
    }

    return service;
}

export function getLang() {
    return getTranslService().getLang();
}

@Injectable({ providedIn: 'root' })
export class TranslService {
    onTranslChange = new Observable((observer) => {
        this.translocoService.langChanges$.subscribe(() => {
            observer.next(true);
        });

        this.translocoService.events$.pipe(filter((e) => e.type === 'translationLoadSuccess')).subscribe(() => {
            observer.next(true);
        });
    });

    constructor(private translocoService: TranslocoService) {}

    t(key: string, defaultVal = null) {
        return translate(key) || (defaultVal !== null && defaultVal !== undefined ? defaultVal : key);
    }

    getLang() {
        return this.translocoService.getActiveLang();
    }
}
